<template>
  <header class="admin-topbar">
    <div class="d-flex align-items-center gap-2">
      <button class="burger" @click="$emit('toggle')"><i class="bi bi-list"></i></button>
      <h1 class="topbar-title">{{ title }}</h1>
    </div>
    <div class="topbar-right">
      <div class="user-chip">
        <span class="avatar">{{ initial }}</span>
        <span class="d-none d-sm-inline">{{ user.name || user.phone }} ({{ role }})</span>
      </div>
      <button class="btn btn-outline-danger btn-sm" @click="onLogout">
        <i class="bi bi-box-arrow-right"></i> Chiqish
      </button>
    </div>
  </header>
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { logout, getRole, getUser } from "../services/auth";
import { useToast } from "../composables/useToast";

defineEmits(["toggle"]);

const route = useRoute();
const router = useRouter();
const toast = useToast();

const role = getRole();
const user = getUser();
const title = computed(() => route.meta.title || "Boshqaruv paneli");
const initial = computed(() =>
  (user.name || user.phone || "A").toString().charAt(0).toUpperCase()
);

function onLogout() {
  logout();
  toast.info("Tizimdan chiqdingiz");
  router.push({ name: "login" });
}
</script>
